<template>
  <div class="modalbox-content">
    <CTabs variant="tabs" class="nav-tabs-boxed subtabs">
      <CTab title="Argumento de Venda">
        <div class="tab-body">
          <div class="form-group">
            <label class="field-label">
              Argumento de Venda
              <BadgeErp campo="argvenda" :camposSincronizados="camposSincronizados" />
            </label>
            <BotaoGerarIA
              :endpoint="`/admin/produtos/${item.id}/gerar-conteudo-ia`"
              campo="argVenda"
              campoLabel="Argumento de Venda"
              :contextoObjeto="item"
              :valorAtual="item.argVenda"
              @generated="item.argVenda = $event"
            />
          </div>
          <CTextarea rows="12" v-model="item.argVenda" />
        </div>
      </CTab>
      <CTab title="Informações Técnicas">
        <div class="tab-body">
          <div class="form-group">
            <label class="field-label">
              Informações Técnicas
              <BadgeErp campo="infotecnicas" :camposSincronizados="camposSincronizados" />
            </label>
            <BotaoGerarIA
              :endpoint="`/admin/produtos/${item.id}/gerar-conteudo-ia`"
              campo="infoTecnicas"
              campoLabel="Informações Técnicas"
              :contextoObjeto="item"
              :valorAtual="item.infoTecnicas"
              @generated="item.infoTecnicas = $event"
            />
          </div>
          <CAlert color="info" class="small">
            Este campo utiliza formato
            <a href="https://pt.wikipedia.org/wiki/Markdown" target="_blank">Markdown</a>.
          </CAlert>
          <v-row>
            <v-col cols="6">
              <label class="field-label">Edição</label>
              <CTextarea rows="12" v-model="item.infoTecnicas" />
            </v-col>
            <v-col cols="6">
              <label class="field-label">Prévia</label>
              <div class="markdown-preview">
                <vue-markdown :source="item.infoTecnicas || ''" />
              </div>
            </v-col>
          </v-row>
        </div>
      </CTab>
      <CTab title="Dados Técnicos">
        <div class="tab-body">
          <div class="form-group">
            <label class="field-label">
              Dados Técnicos
              <BadgeErp campo="dadostecnicos" :camposSincronizados="camposSincronizados" />
            </label>
            <BotaoGerarIA
              :endpoint="`/admin/produtos/${item.id}/gerar-conteudo-ia`"
              campo="dadosTecnicos"
              campoLabel="Dados Técnicos"
              :contextoObjeto="item"
              :valorAtual="item.dadosTecnicos"
              @generated="item.dadosTecnicos = $event"
            />
          </div>
          <CAlert color="info" class="small">
            Este campo utiliza formato
            <a href="https://pt.wikipedia.org/wiki/Markdown" target="_blank">Markdown</a>.
          </CAlert>
          <v-row>
            <v-col cols="6">
              <label class="field-label">Edição</label>
              <CTextarea rows="12" v-model="item.dadosTecnicos" />
            </v-col>
            <v-col cols="6">
              <label class="field-label">Prévia</label>
              <div class="markdown-preview">
                <vue-markdown :source="item.dadosTecnicos || ''" />
              </div>
            </v-col>
          </v-row>
        </div>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import BadgeErp from "@/components/BadgeErp";
import BotaoGerarIA from "@/components/BotaoGerarIA";

export default {
  name: "Conteudo",
  components: { BadgeErp, BotaoGerarIA },
  props: {
    item: { type: Object, required: true },
    camposSincronizados: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.form-group {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab-body {
  padding: 12px 0;
}

.subtabs {
  margin-top: -4px;
}

.markdown-preview {
  border: 1px solid #d8dbe0;
  border-radius: 4px;
  padding: 10px;
  min-height: 200px;
  background: #f9f9fb;
}
</style>
